// extracted by mini-css-extract-plugin
export default {"block":"Awards_block_Kibwm","layout":"Awards_layout_zyGM3","bg":"Awards_bg_Nyiqs","title":"Awards_title_qtkrj","list":"Awards_list_qeURv"};